/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import { ShareIcon } from "./ShareIcon/ShareIcon";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  price: number;
};

export const Price: FcWithoutChildren<Props> = (props) => {
  const { price } = props;

  return (
    <div css={rootStyle}>
      <p>
        <span css={yenStyle}>¥</span>
        <span css={priceStyle}>{price.toLocaleString()}</span>
        {/* TODO: 多言語対応 */}
        <span css={taxStyle}>税込</span>
      </p>

      <div>
        <ShareIcon height={22} width={18} />
      </div>
    </div>
  );
};

const rootStyle = css`
  display: flex;
  justify-content: space-between;
`;

const yenStyle = css`
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
`;

const priceStyle = css`
  display: inline-block;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
  margin-left: 4px;
`;

const taxStyle = css`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  margin-left: 4px;
`;
